import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  IClearerRequest,
  IClearerResponse,
} from '../../models/clearer/clearer.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useCreateClearerUser = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const refreshTableContext = useContext(TableRefreshContext);
  const modalContext = useContext(ModalContext);

  const oncreateClearerUserError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const oncreateClearerUserSuccess = ({
    message,
  }: SuccessHttpResponse<IClearerResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createClearerUser = (data: IClearerRequest) => {
    const url: HttpConfig = {
      url: 'authentication-service/v1/clearers',
      method: 'post',
      data,
    };

    request(
      url,
      oncreateClearerUserSuccess,
      setLoading,
      oncreateClearerUserError
    );
  };

  return { createClearerUser, loading, resetInputFields };
};

export default useCreateClearerUser;
